import axios from 'axios';

import {authService} from '@/auth/AuthServiceInst'

const baseApiUrl = '/api2/uploading';

export default class UploadingService {
    private parser_url: string = null;
    public async getFiles(): Promise<any> {
        let token = await authService.acquireToken();
        return new Promise<any>((resolve, reject) => {
            this.getParserUrl().then(value => {
                axios.get(value.concat("/api/files"), {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }).then(function (res) {
                    resolve(res);
                }).catch(err => {
                    reject(err);
                });
            }).catch(err => {
                reject(err);
            });
        });
    }

    public async process(): Promise<any> {
        let token = await authService.acquireToken();
        return new Promise<any>((resolve, reject) => {
            this.getParserUrl().then(value => {
                axios.get(value.concat("/api/process"), {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }).then(function (res) {
                    resolve(res);
                }).catch(err => {
                    reject(err);
                });
            }).catch(err => {
                reject(err);
            });
        });
    }

    public async getFile(id): Promise<any> {
        let token = await authService.acquireToken();
        return new Promise<any>((resolve, reject) => {
            this.getParserUrl().then(value => {
                axios.get(value.concat(`/api/files/${id}`), {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }).then(function (res) {
                    resolve(res);
                }).catch(err => {
                    reject(err);
                })
            }).catch(err => {
                reject(err);
            });
        });
    }

    public async uploadFile(file, type) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("type", type);
        let token = await authService.acquireToken();
        return new Promise<any>((resolve, reject) => {
            this.getParserUrl().then(value => {
                resolve(
                    axios.post(value.concat("/api/upload"), formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': `Bearer ${token}`
                        }
                    })
                );
            }).catch(err => {
                reject(err);
            })
        });
    }

    private getParserUrl(): Promise<any> {
        const that = this;
        return new Promise<any>((resolve, reject) => {
            if (that.parser_url !== null) {
                resolve(that.parser_url);
                return;
            }
            axios.get(baseApiUrl.concat("/get-parser-url")).then(function (res) {
                that.parser_url = res.data;
                resolve(that.parser_url);
            }).catch(err => {
                reject(err);
            });
        });
    }
}
